module.exports = __webpack_public_path__ + "assets/images/picture-packs_63563b4384cf0ded6970bda3658e0393.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/packs/picture-packs.png
// module id = 220
// module chunks = 0